import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-slide-name',
  templateUrl: './slide-name.component.html',
  styleUrls: ['./slide-name.component.scss']
})
export class SlideNameComponent implements OnInit {

  @Output() slideNameChanged = new EventEmitter<string>();

  public slideName: string = '';
  public Yiit = Yiit;
  public modalMessage = 'Enter Screenshot name';

  constructor() { }

  ngOnInit() {

  }

  confirmSlideName(){
    this.slideNameChanged.emit(this.slideName);
    this.slideName = '';
  }

}
